import { GeneralState } from './types';

export const getGeneral = (state: any): GeneralState => state.general;

export const getShortcutsModalStatusSelector = (state): GeneralState['isShortcutsModalOpen'] =>
    state.general.isShortcutsModalOpen;
